import React, { useState, useRef } from 'react';
import { FormControl, Select, Grid, InputLabel, Tab, MenuItem, Paper, Popover, Stack, Table, TableBody, TableCell, TableContainer, TextField, TableRow, Typography, Card, CardContent } from '@mui/material'
import { Box } from '@mui/system';
import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';
import { monthlyMappingData, growerSubMappingData, hitSubMappingData, lleSubMappingData, transporterSubMappingData } from "./_mock/user";
import { FinancialYearDropdown } from './FinancialYearDropdown';
import { CALCULATE_MONTHLY_ALLOCATION, GET_AVG_MOISTURE_PERCENTAGE, GET_CONSTRAINT, GET_MONTHLY_ALLOCATION, GET_MONTHLY_MAPPINGS, GET_STAKEHOLDER_RATECARD } from '../../common/URLs';
import { loaderService } from '../../common/custom-loader/loader-service';

import { toast } from 'react-toastify';
import { getLocalStorageItem } from '../../common/localStorageUtils';
import apiClient from '../../axios';

function QuickSearchToolbar() {
    return (
        <Box
            sx={{
                p: 0.5,
                pb: 0,
                float: 'right'
            }}
        >
            <GridToolbarQuickFilter />
        </Box>
    );
}

export const MonthlyMapping = () => {
    const [selectedFinancialYear, setSelectedFinancialYear] = useState();
    const [selectedFinancialYearErr, setSelectedFinancialYearErr] = useState('');
    const [planningMonth, setPlanningMonth] = useState('Jan');
    const monthArray = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    const [growerMappingList, setGrowerMappingList] = useState([]);
    const [hitMappingList, setHitMappingList] = useState([]);
    const [transporterMappingList, setTransporterMappingList] = useState([]);
    const [lleMappingList, setLleMappingList] = useState([]);
    const [isMappingList, setIsMappingList] = useState([]);
    const [pageSize, setPageSize] = React.useState(10);
    const [monthlyAllocationData, setMonthlyAllocationData] = useState([]);


    const columns = [
        {
            field: 'mappingType',
            headerName: 'Route Type',
            width: 190,
            headerAlign: 'center',
            align: 'left'
        },
        {
            field: 'growerUrn',
            headerName: 'Grower',
            align: 'left',
            width: 150,
            headerAlign: 'center',
            valueFormatter: (params) => {
                if (params.value === null) {
                    return '-';
                }
            }
        },
        {
            field: 'growerLandId',
            headerName: 'Grower Land ID',
            headerClassName: 'super-app-theme--header',
            width: 300,
            headerAlign: 'center',
            valueFormatter: (params) => {
                if (params.value === null) {
                    return '-';
                }
            }
        },
        {
            field: 'hitUrn',
            headerName: 'HIT',
            width: 150,
            headerAlign: 'center',
            valueFormatter: (params) => {
                if (params.value === null) {
                    return '-';
                }
            }
        },
        {
            field: 'lleUrn',
            headerName: 'LLE',
            width: 150,
            headerAlign: 'center',
            valueFormatter: (params) => {
                if (params.value === null) {
                    return '-';
                }
            }
        },
        {
            field: 'transporterUrn',
            headerName: 'TR',
            width: 150,
            headerAlign: 'center',
            valueFormatter: (params) => {
                if (params.value === null) {
                    return '-';
                }
            }

        },
        {
            field: 'isUrn',
            headerName: 'IS',
            width: 150,
            headerAlign: 'center',
            valueFormatter: (params) => {
                if (params.value === null) {
                    return '-';
                }
            }
        },
        {
            field: 'transporter2',
            headerName: 'TR2',
            width: 150,
            headerAlign: 'center',
            valueFormatter: (params) => {
                if (params.value === null) {
                    return '-';
                }
            }

        },
        {
            field: 'plantName',
            headerName: 'Plant',
            width: 150,
            headerAlign: 'center',
            valueFormatter: (params) => {
                if (params.value === null) {
                    return '-';
                }
            }
        },
        {
            field: 'firstDistance',
            headerName: 'First Distance(in KM)',
            width: 150,
            headerAlign: 'center',
            valueFormatter: (params) => {
                if (params.value === null) {
                    return '-';
                }
            }
        },
        {
            field: 'secondDistance',
            headerName: 'Second Distance(in KM)',
            width: 150,
            headerAlign: 'center',
            valueFormatter: (params) => {
                if (params.value === null) {
                    return '-';
                }
            }
        },
        {
            field: 'growerAvgMoisture',
            headerName: 'Avg % Moisture Grower',
            headerClassName: 'super-app-theme--header',
            width: 200,
            headerAlign: 'center',
            valueFormatter: (params) => {
                if (params.value == 0 || params.value == null) {
                    return '-';
                }
                const valueFormatted = Number(params.value).toLocaleString();
                return `${valueFormatted} %`;
            },
        },
        {
            field: 'lleAvgMoisture',
            headerName: 'Avg % Moisture LLE',
            headerClassName: 'super-app-theme--header',
            width: 200,
            headerAlign: 'center',
            valueFormatter: (params) => {
                if (params.value == 0 || params.value == null) {
                    return '-';
                }
                const valueFormatted = Number(params.value).toLocaleString();
                return `${valueFormatted} %`;
            },
        },
        {
            field: 'perTonCost',
            headerName: 'Per Ton Cost(in INR)',
            width: 110,
            headerAlign: 'center',
        },

    ];
    const growerSubMappingColdef = [
        {
            field: 'stakeholderUrn',
            headerName: 'Grower',
            width: 150
        },
        {
            field: 'growerLandId',
            headerName: 'Land ID',
            width: 300,
        },
        {
            field: 'stakeholderCapacity',
            headerName: 'Capacity(in MT)',
            width: 150
        },
        {
            field: 'stakeholderMbr',
            headerName: 'MBR(in MT)',
            type: 'number',
            width: 90
        },
        {
            field: 'bambooRate',
            headerName: 'Grower Bamboo Rate(INR per MT)',
            width: 180
        },
    ]
    const hitSubMappingColdef = [
        {
            field: 'stakeholderUrn',
            headerName: 'HIT',
            width: 150
        },
        {
            field: 'stakeholderMbr',
            headerName: 'MBR(in MT)',
            width: 110
        },
        {
            field: 'harvestingCost',
            headerName: 'Harvesting Cost(INR per MT)',
            width: 150
        },
        {
            field: 'transportationCost',
            headerName: 'Transportation Cost(INR per KM per MT)',
            width: 150
        }
    ]
    const lleSubMappingColdef = [
        {
            field: 'stakeholderUrn',
            headerName: 'LLE',
            width: 150
        },
        {
            field: 'stakeholderCapacity',
            headerName: 'Chipping Capacity(in MT)',
            headerClassName: 'super-app-theme--header',
            width: 150
        },
        {
            field: 'stakeholderMbr',
            headerName: 'MBR(in MT)',
            width: 150
        },
        {
            field: 'chippingCost',
            headerName: 'Chipping Cost(INR per MT)',
            width: 150
        },
    ]
    const iSsubMappingColdef = [
        {
            field: 'stakeholderUrn',
            headerName: 'IS',
            width: 150
        },
        {
            field: 'stakeholderCapacity',
            headerName: 'Storage Capacity(in MT)',
            width: 150
        },
        {
            field: 'stakeholderMbr',
            headerName: 'MBR(in MT)',
            width: 150
        },
        {
            field: 'storageCost',
            headerName: 'Storage Cost(in INR)',
            width: 150
        },
    ]
    const transporterSubMappingColdef = [
        {
            field: 'stakeholderUrn',
            headerName: 'Transporter',
            width: 150
        },
        {
            field: 'stakeholderMbr',
            headerName: 'MBR(in MT)',
            width: 110
        },
        {
            field: 'transportationCost',
            headerName: 'Transportation Cost(INR per KM per MT)',
            width: 150
        },
    ]
    const handlePlanningMonthChnage = (event) => {
        setPlanningMonth(event.target.value);
        getAvgMoisturePercentage(selectedFinancialYear, event.target.value)
        getStakeholderRatecardApi(selectedFinancialYear, event.target.value);
        // getMonthlyAllocationApi(selectedFinancialYear, event.target.value);

    };

    const getSelectedValue = (dataToBePassed) => {
        setSelectedFinancialYear(dataToBePassed);
        setSelectedFinancialYearErr('');
        getAvgMoisturePercentage(dataToBePassed, planningMonth)
        getStakeholderRatecardApi(dataToBePassed, planningMonth);
        // getMonthlyAllocationApi(dataToBePassed, planningMonth);

    }

    const customGridUiFunction = (colDef, rowValue, type) => {
        return (
            <Card style={{ height: 450 }}>
                <CardContent>
                    <Typography variant='subtitle1' style={{ marginBottom: 5 }}>{type}</Typography>
                    <Box sx={{
                        height: "inherit", width: '100%',
                        '& .super-app-theme--header': {
                            wordWrap: 'break-word',
                            wordBreak: 'break-all',
                            whiteSpace: 'initial',
                        },
                    }}>
                        <DataGrid
                            style={{ height: '100%' }}
                            getRowHeight={() => 'auto'}
                            autoHeight
                            rows={rowValue}
                            columns={colDef}
                            disableSelectionOnClick
                            experimentalFeatures={{ newEditingApi: true }}
                            pagination
                            pageSize={pageSize}
                            onPageSizeChange={(newPage) => setPageSize(newPage)}
                            components={{ Toolbar: QuickSearchToolbar }}

                        />
                    </Box>
                </CardContent>
            </Card>
        )
    }

    // -----------------API Calls-------------------

    const getAvgMoisturePercentage = (year, month) => {
        apiClient.post(GET_AVG_MOISTURE_PERCENTAGE,
            {
                "financialYear": year,
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                let apiData = response.data?.moisturePercentages
                getMonthlyAllocationApi(year, month, apiData)
                loaderService.hideLoader();
            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const getStakeholderConstraintsApi = (year, month, rateCardData) => {
        loaderService.showLoader();
        let tempGrowerData = [];
        let tempLleData = [];
        let tempTransData = [];
        let tempHitData = [];
        let tempIsData = [];

        setLleMappingList([]);
        setGrowerMappingList([]);
        setTransporterMappingList([]);
        setHitMappingList([]);
        setIsMappingList([])

        apiClient.post(GET_CONSTRAINT,
            {
                "financialYear": year,
                "month": month,
                "planningNumber": "test"
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                let apiData = response.data?.demandMonthlyConstraintsLst;
                const result = apiData.map((data1) => {
                    const matchingData2 = rateCardData.find((data2) => {
                        if (data2?.stakeholderType === "Grower" && data1?.growerLandId === data2?.growerLandId && data1?.stakeholderUrn === data2?.stakeholderUrn) {
                            return data1.stakeholderUrn === data2.stakeholderUrn
                        } else if (data2?.stakeholderType === "Transporter") {
                            return data1.stakeholderUrn === data2.stakeholderUrn
                        } else if (data2?.stakeholderType === "HIT") {
                            return data1.stakeholderUrn === data2.stakeholderUrn
                        } else if (data2?.stakeholderType === "LLE") {
                            return data1.stakeholderUrn === data2.stakeholderUrn
                        } else if (data2?.stakeholderType === "IS") {
                            return data1.stakeholderUrn === data2.stakeholderUrn
                        }
                    });
                    if (matchingData2?.stakeholderType === "Grower") {
                        return Object.assign({}, { 'bambooRate': matchingData2?.bambooRate }, data1);
                    } else if (matchingData2?.stakeholderType === "Transporter") {
                        return Object.assign({}, { 'transportationCost': matchingData2?.transportationCost }, data1);
                    } else if (matchingData2?.stakeholderType === "HIT") {
                        return Object.assign({}, { 'transportationCost': matchingData2?.transportationCost, 'harvestingCost': matchingData2?.harvestingCost }, data1);
                    } else if (matchingData2?.stakeholderType === "LLE") {
                        return Object.assign({}, { 'chippingCost': matchingData2?.chippingCost }, data1);
                    } else if (matchingData2?.stakeholderType === "IS") {
                        return Object.assign({}, { 'storageCost': matchingData2?.storageCost }, data1);
                    }
                })
                console.log("result", result)
                if (result?.length !== 0) {
                    result?.map((item) => {
                        if (item?.stakeholderType === 'LLE') {
                            tempLleData.push(item)
                            setLleMappingList(tempLleData);
                        } else if (item?.stakeholderType === 'Transporter') {
                            tempTransData.push(item)
                            setTransporterMappingList(tempTransData);
                        } else if (item?.stakeholderType === 'Grower') {
                            tempGrowerData.push(item)
                            setGrowerMappingList(tempGrowerData);
                        } else if (item?.stakeholderType === 'HIT') {
                            tempHitData.push(item)
                            setHitMappingList(tempHitData);
                        } else if (item?.stakeholderType === 'IS') {
                            tempIsData.push(item)
                            setIsMappingList(tempIsData);
                        }
                    })
                } else {
                    setLleMappingList([]);
                    setGrowerMappingList([]);
                    setTransporterMappingList([]);
                    setHitMappingList([]);
                    setIsMappingList([])
                }
                loaderService.hideLoader();
            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const getMonthlyAllocationApi = (year, month, data) => {
        loaderService.showLoader();
        apiClient.post(GET_MONTHLY_MAPPINGS,
            {
                "financialYear": year,
                "month": month,
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                let apiData = response?.data?.demandStakeholderMappingsLst
                const result = apiData.map((data1) => {
                    const matchingData2 = data.find((data2) => {
                        const data1Id = data1.growerUrn;
                        const data2Id = data2.stakeholderUrn;
                        return data2Id === data1Id
                    });
                    return Object.assign({}, { 'growerAvgMoisture': matchingData2?.avgMoisturePercentage }, data1);
                })
                const finalResult = result.map((data1) => {
                    const matchingData = data.find((data2) => {
                        const data1Id = data1.lleUrn;
                        const data2Id = data2.stakeholderUrn;
                        return data2Id === data1Id
                    });
                    return Object.assign({}, { 'lleAvgMoisture': matchingData ? matchingData?.avgMoisturePercentage : 0 }, data1);
                })
                setMonthlyAllocationData(finalResult);
                loaderService.hideLoader();
            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const getStakeholderRatecardApi = (year, month) => {
        loaderService.showLoader();
        apiClient.post(GET_STAKEHOLDER_RATECARD,
            {
                "financialYear": year,
                "month": month,
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                let apiData = response?.data?.ratecardLst ? response?.data?.ratecardLst.filter((item) => item.stakeholderType === "Grower" || item.stakeholderType === "HIT" || item.stakeholderType === "IS" || item.stakeholderType === "Transporter" || item.stakeholderType === "LLE") : []
                getStakeholderConstraintsApi(year, month, apiData)
                loaderService.hideLoader();
            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }


    return (
        <Grid container spacing={1}>
            <Grid item xs={12} lg={12}>
                <p style={{ textAlign: "right", fontSize: "2vh" }}>DEM03</p>
                <Card>
                    <CardContent>
                        <Grid container spacing={1} style={{ marginBottom: 5 }}>
                            <Grid item xs={6} lg={3}>
                                <FinancialYearDropdown selectedValue={getSelectedValue} helperText={selectedFinancialYearErr} />
                            </Grid>
                            <Grid item xs={6} lg={3}>
                                <FormControl sx={{ width: 200 }} size="small">
                                    <InputLabel id="demo-simple-select-helper-label">Planning Month</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-helper-label"
                                        id="demo-simple-select-helper"
                                        value={planningMonth}
                                        label="Planning Month"
                                        onChange={handlePlanningMonthChnage}
                                    >
                                        {monthArray.map((item) =>
                                            <MenuItem key={item} value={item}>{item}</MenuItem>
                                        )}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} lg={6}>

                            </Grid>
                        </Grid>
                        <Typography variant='subtitle1' style={{ marginBottom: 5 }}>Stakeholder Mapping</Typography>
                        <Box sx={{
                            height: "inherit", width: '100%',
                            '& .super-app-theme--header': {
                                wordWrap: 'break-word',
                                wordBreak: 'break-all',
                                whiteSpace: 'initial',
                            },
                        }}>
                            <DataGrid
                                autoHeight
                                style={{ height: '100%' }}
                                getRowHeight={() => 'auto'}
                                columns={columns}
                                pagination
                                pageSize={pageSize}
                                onPageSizeChange={(newPage) => setPageSize(newPage)}
                                rows={monthlyAllocationData}
                                experimentalFeatures={{ newEditingApi: true }}
                                components={{ Toolbar: QuickSearchToolbar }}
                                getRowClassName={(params) =>
                                    params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                                }
                            />
                        </Box>
                    </CardContent>
                </Card>
            </Grid>
            <Grid item xs={12} lg={12}>{customGridUiFunction(growerSubMappingColdef, growerMappingList, 'Grower Constraints')}</Grid>
            <Grid item xs={12} lg={6}>{customGridUiFunction(hitSubMappingColdef, hitMappingList, 'HIT Constraints')}</Grid>
            <Grid item xs={12} lg={6}> {customGridUiFunction(lleSubMappingColdef, lleMappingList, 'LLE Constraints')}</Grid>
            <Grid item xs={12} lg={6}>{customGridUiFunction(transporterSubMappingColdef, transporterMappingList, 'Transporter Constraints')}</Grid>
            <Grid item xs={12} lg={6}> {customGridUiFunction(iSsubMappingColdef, isMappingList, 'IS Constraints')}</Grid>
        </Grid>

    )
}